import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ITripToUk } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepAdditionalHistoryStep3Info(props: IVisaPrepForm) {
  const renderTripsToUk = () => {
    const allTripsToUK: React.ReactNode[] = [];
    if (props.tripsToUk && props.tripsToUk.length) {
      props.tripsToUk.forEach((ukTrip: ITripToUk, i: number) => {
        allTripsToUK.push(
          <SummaryGroup title={`UK trip ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRIPS_TO_UK_ARRIVAL_DATE}-${i}`}
              label={'Date of Arrival'}
              value={ukTrip.arrivalDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRIPS_TO_UK_DEPARTURE_DATE}-${i}`}
              label={'Date of Departure'}
              value={ukTrip.departureDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.TRIPS_TO_UK_PURPOSE}
              value={ukTrip.purpose}
              label={'Purpose of Trip'}
            />
          </SummaryGroup>,
        );
      });
    }
    return allTripsToUK;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        label="How many trips did you take to the UK?"
        value={props.tripsToUk?.length ?? 0}
      />

      <Box as="ol" pl={8}>
        {renderTripsToUk()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep3Info;
